module.exports = "https://qp-assets.quero.com/assets/images/onboarding/calendar.svg?4c995b6f35b120137a07cb533b687646";